import React from 'react';
import { SeverityBadge } from './SeverityBadge';

export function BadgeList({
  items,
  severityBadges = false,
}: {
  items: string[];
  severityBadges?: boolean;
}) {
  if (!items?.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, i) =>
        severityBadges ? (
          <SeverityBadge key={i} value={item} />
        ) : (
          <span
            key={i}
            className="inline-flex items-center rounded-full border border-border/60 bg-surface-sunken/35 px-2.5 py-1 text-[11px] font-medium tracking-[0.01em] text-foreground/85 shadow-sm"
          >
            {item}
          </span>
        )
      )}
    </div>
  );
}
